module.exports = __webpack_public_path__ + "img/enableScout_01.cacfd20c.png";